export enum ActionType {
  CHOOSE_ORGANIZATION = "choose_organization",
  SET_NETWORK = "set_network",
  CHOOSE_SERVICE = "choose_service",
  REMOVE_SERVICE = "remove_service",

  CHOOSE_BRAND = "choose_brand",
  CHOOSE_GENERATION = "choose_generation",
  CHOOSE_MOTORIZATION = "choose_motorization",
  SET_KEY = "set_key",
  CHOOSE_BODY = "choose_body",
  CHOOSE_GEARBOX = "choose_gearbox",
  SET_MILEAGE = "set_mileage",
  SET_REGISTRATION_DATE = "set_registration_date",
  ADD_EQUIPMENT = "add_equipment",
  REMOVE_EQUIPMENT = "remove_equipment",

  CHOOSE_GARAGE = "choose_garage",
  REMOVE_GARAGE = "remove_garage",
  CHOOSE_PLACE = "choose_place",
  CHOOSE_SLOT = "choose_slot",
  ADD_PREMIUM_SERVICE = "add_premium_service",
  REMOVE_PREMIUM_SERVICE = "remove_premium_service",
  CLEAR_PREMIUM_SERVICES = "clear_premium_services",

  SET_FIRST_NAME = "set_first_name",
  SET_LAST_NAME = "set_last_name",
  SET_EMAIL = "set_email",
  SET_PHONE = "set_phone",
  SET_NUMBERPLATE = "set_number_plate",

  CHANGE_DATES_FILTER = "change_dates_filter",
  CHANGE_DISTANCE_FILTER = "change_distance_filter",
  CHANGE_NAME_FILTER = "change_name_filter",
  CHANGE_SORT_BY_FILTER = "change_sort_by_filter",
  CHANGE_BEV_SUPPORT_FILTER = "change_bev_support_filter",
  CHANGE_COMMERCIAL_VEHICLE_SUPPORT_FILTER = "change_commercial_vehicle_support_filter",

  CHANGE_BRAND_FILTER = "change_brand_filter",

  ADD_SUB_REPAIR = "add_sub_repair",
  REMOVE_SUB_REPAIR = "remove_sub_repair",

  SET_CONTRACT_DETAILS = "set_contract_details",
  UPDATE_CONTRACT_DETAILS = "update_contract_details",
  SET_DELIVERY_DATES = "set_delivery_dates",
  DISMISS_MODAL = "dismiss_modal",
  CHANGE_BOOKABLE_FILTER = "change_bookable_filter",
  CHANGE_ONLYMANUFACTURER_FILTER = "change_onlymanufacturer_filter",
  SET_GARAGE_CHAINS = "set_garage_chains",
  CHANGE_SHOW_AS_NONBOOKABLE = "change_show_as_nonbookable",
  SET_USER_ID = "set_user_id",
  SET_DRIVER_DATA = "set_driver_data",
  SET_RENTAL_CAR_SELECTION = "set_rental_car_selection",
  SET_FLEET_MANAGER_DATA = "set_fleet_manager_data",
  SET_ROLE = "set_role",
  SET_INITIAL_TOKEN = "set_initial_token",
  SET_TOKEN = "set_token",
  SET_INITIAL_ROLE = "set_initial_role",
  SET_PRESET_FILTER = "set_preset_filter",
  SET_VIN = "set_vin",
  SET_HSNTSN = "set_hsntsn",
  SET_CONTRACT_NUMBER = "set_contract_number",
  SET_MESSAGE = "set_message",
  SET_CLAIM_NUMBER = "set_claim_number",
  SET_STREET = "set_street",
  SET_CITY = "set_city",
  SET_POSTCODE = "set_postcode",
  SET_ADDITION = "set_addition",
  SET_USER_CONFIRMED_ADDRESS = "set_user_confirmed_address",
  SET_MUST_USE_AUTHORIZED_GARAGE = "set_must_use_authorized_garage",
  SET_REVIEW_OPT_IN = "set_review_opt_in",
}
